import { NAMESPACE as PACKAGE_NAMESPACE } from '../../constants';

export const NAMESPACE = `${PACKAGE_NAMESPACE}/purchase`;
export const FETCH_PLANS = `${PACKAGE_NAMESPACE}/fetchPlans`;
